"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 获取是否开启 https 对象链接
 * @param secure 是否开启 htttps
 * @param url 对象上传路径
 */
function getCosObjectUrl(secure, url) {
    return secure ? "https://" + url : "http://" + url;
}
/**
 * 初始化SDK实例
 * @param config 配置项
 * @returns SDK实例
 */
function initClient(SDK, config) {
    var accessKeyId = config.accessKeyId, accessKeySecret = config.accessKeySecret, stsToken = config.stsToken, startTime = config.startTime, expiredTime = config.expiredTime;
    return new SDK({
        getAuthorization: function (options, callback) {
            console.log(options);
            callback({
                TmpSecretId: accessKeyId,
                TmpSecretKey: accessKeySecret,
                XCosSecurityToken: stsToken,
                StartTime: startTime,
                ExpiredTime: expiredTime
            });
        }
    });
}
/**
 * 分段上传
 * @param client SDK实例
 * @param file 需要上传的文件
 * @param uploadConfig 上传配置
 * @param userConfig 实例的配置
 * @returns Promise
 */
function upload(client, file, uploadConfig, userConfig) {
    var key = userConfig.key, headers = userConfig.headers, region = userConfig.region, bucket = userConfig.bucket;
    return new Promise(function (resolve, reject) {
        client.sliceUploadFile({
            Bucket: bucket,
            Region: region,
            Key: key,
            Body: file,
            Headers: headers,
            onProgress: function (_a) {
                var percent = _a.percent;
                uploadConfig.progress(percent);
            }
        }, function (error, data) {
            if (!error) {
                var statusCode = data.statusCode, Location_1 = data.Location, Key = data.Key;
                resolve({
                    status: statusCode,
                    data: {
                        url: getCosObjectUrl(userConfig.secure, Location_1),
                        key: Key
                    }
                });
            }
            else {
                reject({
                    message: '上传失败'
                });
            }
        });
    });
}
/**
 * 图片处理
 * @param url 图片链接
 * @param config 配置参数
 * @returns 返回图片处理 url 拼接字符串
 */
function processImage(url, config) {
    var processURL = url + "?imageView2/2/w/" + config.resize.w;
    if (config.resize.h) {
        processURL += "/h/" + config.resize.h;
    }
    return processURL;
}
exports.default = {
    initClient: initClient,
    upload: upload,
    processImage: processImage
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTs7OztHQUlHO0FBQ0gsU0FBUyxlQUFlLENBQUMsTUFBTSxFQUFFLEdBQUc7SUFDbEMsT0FBTyxNQUFNLENBQUMsQ0FBQyxDQUFDLGFBQVcsR0FBSyxDQUFDLENBQUMsQ0FBQyxZQUFVLEdBQUssQ0FBQTtBQUNwRCxDQUFDO0FBRUQ7Ozs7R0FJRztBQUNILFNBQVMsVUFBVSxDQUFDLEdBQVEsRUFBRSxNQUFtQjtJQUN2QyxJQUFBLGdDQUFXLEVBQUUsd0NBQWUsRUFBRSwwQkFBUSxFQUFFLDRCQUFTLEVBQUUsZ0NBQVcsQ0FBVztJQUNqRixPQUFPLElBQUksR0FBRyxDQUFDO1FBQ2IsZ0JBQWdCLEVBQUUsVUFBQyxPQUFPLEVBQUUsUUFBUTtZQUNsQyxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFBO1lBQ3BCLFFBQVEsQ0FBQztnQkFDUCxXQUFXLEVBQUUsV0FBVztnQkFDeEIsWUFBWSxFQUFFLGVBQWU7Z0JBQzdCLGlCQUFpQixFQUFFLFFBQVE7Z0JBQzNCLFNBQVMsRUFBRSxTQUFTO2dCQUNwQixXQUFXLEVBQUUsV0FBVzthQUN6QixDQUFDLENBQUE7UUFDSixDQUFDO0tBQ0YsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQUVEOzs7Ozs7O0dBT0c7QUFDSCxTQUFTLE1BQU0sQ0FBQyxNQUFXLEVBQUUsSUFBVSxFQUFFLFlBQW1DLEVBQUUsVUFBdUI7SUFDM0YsSUFBQSxvQkFBRyxFQUFFLDRCQUFPLEVBQUUsMEJBQU0sRUFBRSwwQkFBTSxDQUFlO0lBRW5ELE9BQU8sSUFBSSxPQUFPLENBQUMsVUFBQyxPQUFPLEVBQUUsTUFBTTtRQUNqQyxNQUFNLENBQUMsZUFBZSxDQUFDO1lBQ3JCLE1BQU0sRUFBRSxNQUFNO1lBQ2QsTUFBTSxFQUFFLE1BQU07WUFDZCxHQUFHLEVBQUUsR0FBRztZQUNSLElBQUksRUFBRSxJQUFJO1lBQ1YsT0FBTyxFQUFFLE9BQU87WUFDaEIsVUFBVSxFQUFFLFVBQUMsRUFBVztvQkFBVCxvQkFBTztnQkFDcEIsWUFBWSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQTtZQUNoQyxDQUFDO1NBQ0YsRUFBRSxVQUFDLEtBQUssRUFBRSxJQUFJO1lBQ2IsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDRixJQUFBLDRCQUFVLEVBQUUsMEJBQVEsRUFBRSxjQUFHLENBQVM7Z0JBQzFDLE9BQU8sQ0FBQztvQkFDTixNQUFNLEVBQUUsVUFBVTtvQkFDbEIsSUFBSSxFQUFFO3dCQUNKLEdBQUcsRUFBRSxlQUFlLENBQUMsVUFBVSxDQUFDLE1BQU0sRUFBRSxVQUFRLENBQUM7d0JBQ2pELEdBQUcsRUFBRSxHQUFHO3FCQUNUO2lCQUNGLENBQUMsQ0FBQTthQUNIO2lCQUFNO2dCQUNMLE1BQU0sQ0FBQztvQkFDTCxPQUFPLEVBQUUsTUFBTTtpQkFDaEIsQ0FBQyxDQUFBO2FBQ0g7UUFDSCxDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUMsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQUVEOzs7OztHQUtHO0FBQ0gsU0FBUyxZQUFZLENBQUMsR0FBVyxFQUFFLE1BQTBCO0lBQzNELElBQUksVUFBVSxHQUFNLEdBQUcsd0JBQW1CLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBRyxDQUFBO0lBQzNELElBQUksTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUU7UUFDbkIsVUFBVSxJQUFJLFFBQU0sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFHLENBQUE7S0FDdEM7SUFDRCxPQUFPLFVBQVUsQ0FBQTtBQUNuQixDQUFDO0FBRUQsa0JBQWU7SUFDYixVQUFVLFlBQUE7SUFDVixNQUFNLFFBQUE7SUFDTixZQUFZLGNBQUE7Q0FDYixDQUFBIn0=